// ForgetPassword.js
import React from 'react';
import styled from 'styled-components';
import logo from "../assets/image.png";

const LoginPage = styled.div`
  display: flex;
  height: 100vh;
  background-color: #fff;
`;

const LeftContainer = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #FF9854;
`;

const RightContainer = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 20px;
  background-color: #FFF;
`;

const Logo = styled.img`
  width: 80%;
  max-width: 300px;
`;

const LoginForm = styled.form`
  max-width: 300px;
  width: 100%;
`;

const InputField = styled.input`
  width: 100%;
  padding: 12px;
  margin-bottom: 20px;
  border: 1px solid #ddd;
  border-radius: 4px;
  box-sizing: border-box;
  font-size: 16px;
`;

const LoginButton = styled.button`
  width: 100%;
  padding: 15px;
  background-color: #F35424;
  color: #fff;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 16px;
  transition: background-color 0.3s ease;

  &:hover {
    background-color: #D0401F;
  }
`;

const RightContent = styled.div`
  text-align: center;
`;

const AdminHeading = styled.h3`
  font-size: 24px;
  margin-bottom: 10px;
`;

const AccountDescription = styled.p`
  font-size: 16px;
  color: #555;
  margin-bottom: 20px;
`;

const AppLink = styled.a`
  color: #e74c3c;
  text-decoration: none;
  font-weight: bold;
  display: inline-block;
  height: 20px;
  margin-top: 10px;

  &:hover {
    text-decoration: underline;
  }
`;

const FlexContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 14px;
  margin-top: 15px;
`;

const KeepMeLoggedIn = styled.span`
  display: flex;
  align-items: center;
  margin-right: 20px;
`;

const KeepMeLoggedInCheckbox = styled.input`
  margin-right: 5px;
`;

const ForgetPassword = () => {
  return (
    <LoginPage>
      <LeftContainer>
        <Logo src={logo} alt="Company Logo" />
      </LeftContainer>
      <RightContainer>
        <RightContent>
          <AdminHeading>Admin</AdminHeading>
          <AccountDescription>Forget Password</AccountDescription>
          <LoginForm>
            <InputField type="text" placeholder="Email ID" />
            <LoginButton type="submit">Send Link</LoginButton>
          </LoginForm>
          
        </RightContent>
      </RightContainer>
    </LoginPage>
  );
};

export default ForgetPassword;
